import { getJson, postJson, putJson } from './baseApi'

export const fetchBillingTermsByListingId = (listingId) => {
	return getJson(`/api/marketplace/billing/terms/listing/${listingId}`)
}

export const updateBillingTerms = (subscriptionId, command) => {
	return putJson(`/api/marketplace/billing/terms/${subscriptionId}/update-billing-terms`, command)
}
